module.exports = __webpack_public_path__ + "media/images/pic/saska/online_lessons-6fae2baf7981af97b3c80ca1a7ea9718.svg";